import { Formik } from "formik"
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap"
import { Formato } from "../../types"
import { Button } from "@inmagik/magik-ui"
import { initialValuesFormato, validationSchemaFormato } from "./FormatoCommon"
import { useMemo } from "react"
import FormatoForm from "./FormatoForm"

export default function FormatoModal({
  title,
  formato,
  save,
  show,
  onClose,
}: {
  title: string
  formato?: Formato
  save: (values: Formato, actions: { setErrors: (errors: any) => void }) => Promise<void>
  show: boolean
  onClose: () => void
}) {

  const initialValues = useMemo(() => initialValuesFormato(formato) as Formato, [formato])
  const validationSchema = useMemo(() => validationSchemaFormato(), [])

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={save}
    >
      {({ handleSubmit }) => (
        <Modal centered show={show} onHide={onClose} size="lg" backdrop="static">
          <form onSubmit={handleSubmit}>
            <ModalHeader>
              <ModalTitle>{title}</ModalTitle>
            </ModalHeader>
            <ModalBody
              style={{
                maxHeight: "calc(100vh - 200px)",
                overflowY: "auto",
              }}
            >
              <FormatoForm col={12} />
            </ModalBody>
            <ModalFooter className="d-flex justify-content-between">
              <Button onClick={onClose} title="Annulla" size="md" outline leadingIcon="close" />
              <Button type="submit" title="Salva" size="md" leadingIcon="check" className="text-white" />
            </ModalFooter>
          </form>
        </Modal>
      )}
    </Formik>
  )
}
